export default __webpack_public_path__ + "static/media/hello-text.0b14cebf.svg";